import { render, staticRenderFns } from "./DetailsOfAssignments.vue?vue&type=template&id=9e712698"
import script from "./DetailsOfAssignments.vue?vue&type=script&lang=js"
export * from "./DetailsOfAssignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports